import has from './has';
export default has;
//# sourceMappingURL=has-key.js.map